import React from 'react';
import { motion } from 'framer-motion';
export function PlanSection() {
  const steps = [{
    days: 'Día 1–2',
    title: 'Evaluación y Preparación',
    desc: 'Evalúa la dinámica actual y prepara el cambio sin fricción.',
    color: 'bg-[#0ABFBC]'
  }, {
    days: 'Día 3–5',
    title: 'Implementación Estratégica',
    desc: 'Aplica estrategias prácticas para reducir el uso excesivo de pantalla.',
    color: 'bg-[#F97316]'
  }, {
    days: 'Día 6–7',
    title: 'Mantenimiento',
    desc: 'Establece límites sostenibles que se mantengan en el tiempo.',
    color: 'bg-[#1a1a2e]'
  }];
  return <section className="py-8 bg-[#FAFAF8]" data-id="element-118">
      <div className="container mx-auto px-4" data-id="element-119">
        <div className="text-center mb-8" data-id="element-120">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a2e] mb-4 font-montserrat" data-id="element-121">
            Así funciona el plan de 7 días
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-122">
            Todo explicado paso a paso para que puedas aplicarlo de inmediato.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-5 max-w-6xl mx-auto" data-id="element-123">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white p-5 rounded-2xl shadow-lg border border-gray-100 relative overflow-hidden group hover:-translate-y-2 transition-transform duration-300" data-id="element-124">
              <div className={`absolute top-0 left-0 w-full h-2 ${step.color}`} data-id="element-125" />

              <div className={`inline-block px-3 py-1 rounded-full text-xs font-bold text-white mb-3 ${step.color}`} data-id="element-126">
                {step.days}
              </div>

              <h3 className="text-xl font-bold text-[#1a1a2e] mb-2 font-montserrat" data-id="element-127">
                {step.title}
              </h3>

              <p className="text-gray-600 leading-relaxed" data-id="element-128">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}